import { render } from "./ChoicesCombinationsInput.vue?vue&type=template&id=d151ef60&scoped=true"
import script from "./ChoicesCombinationsInput.vue?vue&type=script&lang=js"
export * from "./ChoicesCombinationsInput.vue?vue&type=script&lang=js"

import "./ChoicesCombinationsInput.vue?vue&type=style&index=0&id=d151ef60&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d151ef60"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QField,QIcon});
